import { Header, StyledReactMarkdown } from './styled';
import { OneColumn } from '@/components/Layout';
import { Row } from '@simplywallst/ui-core';
import { usePageTranslation } from '../../hooks/usePageTranslation';

export const CompareFeatures = () => {
  const t = usePageTranslation();
  return (
    <Row justifyContent="center">
      <OneColumn>
        <Header>{t('compare.title')}</Header>
        <Row justifyContent="center">
          <StyledReactMarkdown tableIndex={0}>
            <table>
              <thead>
                <tr>
                  <th>{t('compare.table1.header')}</th>
                  <th>{t('compare.table1.free')}</th>
                  <th>{t('compare.table1.premium')}</th>
                  <th>{t('compare.table1.unlimited')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{t('compare.table1.globalMarketAccess')}</td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                </tr>
                <tr>
                  <td>{t('compare.table1.curatedIdeas')}</td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                </tr>
                <tr>
                  <td>{t('compare.table1.samplePortfolios')}</td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                </tr>
                <tr>
                  <td>{t('compare.table1.screenersAlerts')}</td>
                  <td>{t('compare.table1.limited')}</td>
                  <td>{t('compare.table1.alerts3')}</td>
                  <td>{t('compare.table1.alerts10')}</td>
                </tr>
              </tbody>
            </table>
          </StyledReactMarkdown>

          <StyledReactMarkdown tableIndex={1}>
            <table>
              <thead>
                <tr>
                  <th>{t('compare.table2.header')}</th>
                  <th>{t('compare.table1.free')}</th>
                  <th>{t('compare.table1.premium')}</th>
                  <th>{t('compare.table1.unlimited')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{t('compare.table2.stockReports')}</td>
                  <td>{t('compare.table2.reports5')}</td>
                  <td>{t('compare.table2.reports30')}</td>
                  <td>{t('compare.table2.reportsUnlimited')}</td>
                </tr>
                <tr>
                  <td>{t('compare.table2.exportPdf')}</td>
                  <td></td>
                  <td></td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </StyledReactMarkdown>

          <StyledReactMarkdown tableIndex={2}>
            <table>
              <thead>
                <tr>
                  <th>{t('compare.table3.header')}</th>
                  <th>{t('compare.table1.free')}</th>
                  <th>{t('compare.table1.premium')}</th>
                  <th>{t('compare.table1.unlimited')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{t('compare.table3.numPortfolios')}</td>
                  <td>{t('compare.table3.portfolios1')}</td>
                  <td>{t('compare.table3.portfolios3')}</td>
                  <td>{t('compare.table3.portfolios5')}</td>
                </tr>
                <tr>
                  <td>{t('compare.table3.numHoldings')}</td>
                  <td>{t('compare.table3.holdings10')}</td>
                  <td>{t('compare.table3.holdings30')}</td>
                  <td>{t('compare.table3.transactionsUnlimited')}</td>
                </tr>
                <tr>
                  <td>{t('compare.table3.transactions')}</td>
                  <td>{t('compare.table3.transactionsUnlimited')}</td>
                  <td>{t('compare.table3.transactionsUnlimited')}</td>
                  <td>{t('compare.table3.transactionsUnlimited')}</td>
                </tr>
                <tr>
                  <td>{t('compare.table3.returns')}</td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="https://support.simplywall.st/hc/en-us/articles/11111546059919-Linking-Your-Broker-to-Simply-Wall-St">
                      {t('compare.table3.brokerageLinking')}
                    </a>
                  </td>
                  <td></td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      href="https://support.simplywall.st/hc/en-us/articles/7563299190159-What-important-updates-and-events-are-being-sent-to-me"
                      title="Important updates"
                    >
                      {t('compare.table3.importantUpdates')}
                    </a>
                  </td>
                  <td>{t('compare.table3.updatesLimited')}</td>
                  <td>{t('compare.table3.updatesUnlimited')}</td>
                  <td>{t('compare.table3.updatesUnlimited')}</td>
                </tr>
                <tr>
                  <td>{t('compare.table3.weeklyPortfolio')}</td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                </tr>
                <tr>
                  <td>{t('compare.table3.weeklyInsights')}</td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                  <td>
                    <img
                      alt="tick"
                      src="//images.ctfassets.net/n07nr2koi959/6nx9Vt6iavyLvdRel8d4BQ/c5aedf6a7a5ae60c2cd46606827e8062/tick.svg"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </StyledReactMarkdown>
        </Row>
      </OneColumn>
    </Row>
  );
};
